import * as types from './usersActionTypes';

const initialState = {
  userData: null,
  userList: null,
  userHistorySortData: null,
  error: {
    type: null,
    data: null,
  },
  createUserData: null,
  createUserError: null,
  updateUserData: null,
  updateUserError: null,
  deleteUserData: null,
  deleteUserError: null,
  resetUserPasswordData: null,
  resetUserPasswordError: null,
  changeUserPasswordData: null,
  changeUserPasswordError: null,
  getUserDetailsData: null,
  getUserDetailsError: null,
};

export const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_USER_DATA:
      console.log('GET_USER_DATA action?.payload')
      console.log(action?.payload)
      return {
        ...state,
        userData: action?.payload ? { ...action?.payload } : null,
        userList: action?.payload?.UserList ? 
         [...action?.payload.UserList] : [],
      };
    case types.GET_USER_ERROR:
      return {
        ...state,
        error: {
          type: types.GET_USER_ERROR,
          data: action.payload,
        },
      };
    case types.SET_USER_HISTORY_SORT_DATA:
      return {
        ...state,
        userHistorySortData: {
          orderBy: action.payload.orderBy,
          order: action.payload.order
        }
      };
    case types.CREATE_USER_REQUEST:
      return {
        ...state,
        createUserError: null,
      };
     
    case types.CREATE_USER_DATA:
      return {
        ...state,
        createUserData: action.payload,
        createUserError: null,
      };
     
    case types.CREATE_USER_ERROR:
      return {
        ...state,
        createUserData: null,
        createUserError: action.payload,
      };
     
    case types.UPDATE_USER_REQUEST:
      return {
        ...state,
        updateUserError: null,
      };
     
    case types.UPDATE_USER_DATA:
      return {
        ...state,
        updateUserData: action.payload,
        updateUserError: null,
      };
     
    case types.UPDATE_USER_ERROR:
      return {
        ...state,
        updateUserData: null,
        updateUserError: action.payload,
      };
     
    case types.DELETE_USER_REQUEST:
      return {
        ...state,
        deleteUserError: null,
      };
     
    case types.DELETE_USER_DATA:
      return {
        ...state,
        deleteUserData: action.payload,
        deleteUserError: null,
      };
     
    case types.DELETE_USER_ERROR:
      return {
        ...state,
        deleteUserData: null,
        deleteUserError: action.payload,
      };

    case types.RESET_USER_PASSWORD_REQUEST:
      return {
        ...state,
        resetUserPasswordError: null,
        resetUserPasswordData: null,
      };
     
    case types.RESET_USER_PASSWORD_DATA:
      return {
        ...state,
        resetUserPasswordData: action.payload,
        resetUserPasswordError: null,
      };
     
    case types.RESET_USER_PASSWORD_ERROR:
      return {
        ...state,
        resetUserPasswordData: null,
        resetUserPasswordError: action.payload,
      };

    case types.CHANGE_USER_PASSWORD_REQUEST:
      return {
        ...state,
        changeUserPasswordError: null,
        changeUserPasswordData: null,
      };
     
    case types.CHANGE_USER_PASSWORD_DATA:
      return {
        ...state,
        changeUserPasswordData: action.payload,
        changeUserPasswordError: null,
      };
     
    case types.CHANGE_USER_PASSWORD_ERROR:
      return {
        ...state,
        changeUserPasswordData: null,
        changeUserPasswordError: action.payload,
      };
      case types.GET_USER_DETAILS_REQUEST:
      console.log('Reducer - GET_USER_DETAILS_REQUEST');
      return {
        ...state,
        getUserDetailsError: null,
        getUserDetailsData: null,
      };
     
    case types.GET_USER_DETAILS_DATA:
      console.log('Reducer - GET_USER_DETAILS_DATA:', action.payload);
      return {
        ...state,
        getUserDetailsData: action.payload,
        getUserDetailsError: null,
      };
     
    case types.GET_USER_DETAILS_ERROR:
      console.log('Reducer - GET_USER_DETAILS_ERROR:', action.payload);
      return {
        ...state,
        getUserDetailsData: null,
        getUserDetailsError: action.payload,
      };
     
    default:
      return state;
  }
};